var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 657,
    height: 466,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "118%",
    height: "126.9%",
    x: "-9%",
    y: "-5.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 578,
    height: 385,
    rx: 26
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "126%",
    height: "139%",
    x: "-13%",
    y: "-11.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 30,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.18243335 0 0 0 0 0.230632694 0 0 0 0 0.506057518 0 0 0 0.200120192 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "99.013%",
    x2: "2.544%",
    y1: "71.675%",
    y2: "29.014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "e",
    width: 536,
    height: 346,
    y: 3,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#a)",
    transform: "translate(39 9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#777",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 574.23,
    height: 381.865,
    x: 2,
    y: 2,
    fill: "url(#d)",
    fillRule: "nonzero",
    rx: 25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.03 16.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 471.463,
    height: 353.756,
    x: 33,
    fill: "#2A2A2A",
    fillRule: "nonzero",
    opacity: 0.1,
    rx: 5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E8EAF6",
    fillRule: "nonzero",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5267DF",
    d: "M-3.53 3.197h547v59h-547z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.47 17.197)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    opacity: 0.245
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 16,
    r: 16,
    opacity: 0.104
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    opacity: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    y: 14,
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 316,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 316,
    x: 295,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 78.47,
    y: 38.197,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 26,
    r: 16,
    fill: "#F98E5D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 40,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 60,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 94,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 114,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 134,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 30,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6AC6D6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 257)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A47ED4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110 313)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EC7878"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHero);
export default __webpack_public_path__ + "static/media/illustration-hero.07801d05cb11930f0c826add8c05ce22.svg";
export { ForwardRef as ReactComponent };